import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function QualificationList() {
  const navigate = useNavigate();
  const columns = [
    { field: "QL_Id", label: "#" },
    { field: "QL_Name", label: "Qualification" },
    { field: "QL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.QL_Id));

        navigate(
          `/QualificationLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Qualification/list`}
      actions={actions}
      title={`Qualification`}
      linkvalue={`/QualificationLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default QualificationList;
